<div id="loginOverlay" class="overlay full login">
  <div id="loginContainer" class="login-container">
    <div id="loginLogo" class="crm-industrial-font icon-snapon-logo"></div>
    @if (showLogin) {
      <ng-container id="loginContent">
        <h1 id="loginSalutation" class="heading text-center">{{appStrings.label_hi}} {{userData.UserInfo.Name || userData.UserInfo.sub}}!</h1>
        <p id="loginTooltipText" class="text-center">{{appStrings.label_enterPassword}}</p>
        <mat-form-field id="loginFormField" appearance="outline" class="pass-field">
          <mat-label id="primaryAddressLabel">{{appStrings.label_offlineToken}}</mat-label>
          <input matInput id="offlineTokenField" [(ngModel)]="offlineToken" type="password" (keyup.enter)="submitLogin()"
            autofocus />
          </mat-form-field>
          <p id="loginError" class="error">{{error}}</p>
          <p id="loginTroubleLink" class="trouble" [ngClass]="{'shown': error}" (click)="toggleForgotPasswordScreen()">
          {{appStrings.label_troubleLoggingIn}}</p>
          <button mat-button id="offlineLoginSubmit" class="button primary"
          (click)="submitLogin()">{{appStrings.button_login}}</button>
        </ng-container>
      } @else {
        <a id="login_backToLogin" class="back-link" (click)="toggleForgotPasswordScreen()">
          <span class="crm-industrial-font icon-back"></span> {{appStrings.link_backToLogin}} </a>
          <div class="grid-wrapper">
            <div class="steps">
              <h1 id="loginForgot" class="heading">{{appStrings.label_forgotPassword}}</h1>
              <p id="loginForgotStep1" class="step">{{appStrings.label_forgotPasswordStep1}}</p>
              <p id="loginForgotStep2" class="step">{{appStrings.label_forgotPasswordStep2}}</p>
              <p id="loginForgotStep3" class="step">{{appStrings.label_forgotPasswordStep3}}</p>
            </div>
            <div id="loginForgotIcon" class="icon-wrapper">
              <span class="crm-industrial-font icon-internet-base"></span>
              <span class="crm-industrial-font icon-internet-wire animate-top"></span>
            </div>
          </div>
          <p id="loginForgotStep4" class="step">{{appStrings.label_forgotPasswordStep4}}</p>
          <div class="button-container">
            <button mat-button id="offlineLoginGoOnline" class="button primary"
            (click)="goOnline()">{{appStrings.goOfflineDashboard_goOnlineButton}}</button>
            <a id="contactSupportLink" href="mailto:help@snapon.com">
              <button mat-button class="button">{{appStrings.button_contactCustomerSupport}}</button>
            </a>
          </div>
        }
      </div>

    </div>